module.exports = __webpack_public_path__ + "static/media/Electricity.2515cd46.png";